var $class="se2--header-se--promo-banner",$name="HeaderSE/promoBanner",$path="app/components/HeaderSE/partials/promoBanner/config.js",$this={$class,$name,$path,};export const localStorageKey = 'promoNotificationBannerTimeStamp';
export const closeButtonSelector = '.close-button';
export const buttonSelector = '.button';
